import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import Vuelidate from 'vuelidate'
import VueCookie from 'vue-cookie'
import api from '@/utils/api'
import i18n from '@/utils/i18n'
import Toast from '@/components/Toast'
import '@/directives/visible'

function main () {
  Vue.use(VueLocalStorage)
  Vue.use(Vuelidate)
  Vue.use(VueCookie)
  Vue.use(Toast)

  Vue.config.productionTip = false
  setLang()
  Vue.prototype.$api = api
  Vue.prototype.$bus = new Vue()

  new Vue({
    router,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}

function setLang () {
  let referrerComRx = new RegExp('://platformcraft.com')
  let lang = VueCookie.get('lang') || 'ru'
  if (lang === 'en-US') {
    lang = 'en'
  } else if (referrerComRx.test(document.referrer)) {
    lang = 'en'
    Vue.cookie.set('lang', 'en-US')
  }
  i18n.locale = lang
}

api.getCSRF().then(({ data }) => {
  if (data.isAuth) {
    window.location.href = '/home'
    return
  }
  api.setCSRF(data)
  main()
}).catch(main)
